import { Navigate, Outlet } from "react-router";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { EnvironmentBanner } from "../../layout";
import {
  useOnboardingEnabled,
  useOnboardingEnvironmentBannerEnabled,
} from "../hooks";
import s from "./OnboardingLayout.module.css";

/**
 * Route guard + shell for the onboarding portal. The entire `/onboarding`
 * subtree is gated on the `enable-onboarding` LaunchDarkly flag:
 * - while flags are still loading, render nothing (avoids a redirect flash);
 * - when the flag is off, redirect home;
 * - when on, render the standard workspace shell around the section.
 *
 * The deployment-environment banner is scoped here (Onboarding only) rather
 * than in the global `Layout` — it was a Professional Services-specific
 * request, not a platform-wide one. Visibility is gated by
 * `enable-onboarding-environment-banner` (`useOnboardingEnvironmentBannerEnabled`).
 */
export function OnboardingLayout() {
  const { isEnabled, isLoaded } = useOnboardingEnabled();
  const showEnvironmentBanner = useOnboardingEnvironmentBannerEnabled();

  if (!isLoaded) {
    return null;
  }

  if (!isEnabled) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={s.root}>
      {showEnvironmentBanner ? <EnvironmentBanner /> : null}
      <div className={s.shell}>
        <WorkspaceScreen wide utilityHeader>
          <Outlet />
        </WorkspaceScreen>
      </div>
    </div>
  );
}
